import React, { useState, useEffect } from 'react';
import appStoreLogo from '../../assets/home/appStoreLogo.svg';
import googlePlayLogo from '../../assets/home/googlePlayLogo.png';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

export const AppsButtonContainer = ({ isColumn = '' }) => {
    const { lang } = useParams(); // Get 'lang' from the URL
    const [show, setShow] = useState(false);
    const [playStoreUrl, setPlayStoreUrl] = useState('https://play.google.com/store/apps/details?id=de.netzlab.findtogether');
    
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        // Build Play Store URL with click ID and UTM parameters
        const buildPlayStoreUrl = () => {
            const baseUrl = 'https://play.google.com/store/apps/details';
            const packageId = 'de.netzlab.findtogether';
            
            try {
                const url = new URL(baseUrl);
                url.searchParams.set('id', packageId);
                
                // Get click ID from localStorage
                const clickId = localStorage.getItem('ft_click_id');
                
                // Get UTM parameters from current URL
                const currentParams = new URLSearchParams(window.location.search);
                
                // Build referrer parameter
                const referrerParams = new URLSearchParams();
                
                if (clickId) {
                    referrerParams.set('click_id', clickId);
                }
                
                // Add UTM parameters if available
                const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
                utmParams.forEach(param => {
                    const value = currentParams.get(param);
                    if (value) {
                        referrerParams.set(param, value);
                    }
                });
                
                // Add referrer to Play Store URL if we have parameters
                if (referrerParams.toString()) {
                    url.searchParams.set('referrer', referrerParams.toString());
                }
                
                setPlayStoreUrl(url.toString());
            } catch (error) {
                console.error('Error building Play Store URL:', error);
            }
        };

        buildPlayStoreUrl();
        
        // Update URL when localStorage changes (e.g., when click is tracked)
        const handleStorageChange = () => {
            buildPlayStoreUrl();
        };
        
        window.addEventListener('storage', handleStorageChange);
        
        // Also listen for custom event from custom.js
        const handleClickIdUpdate = () => {
            buildPlayStoreUrl();
        };
        
        window.addEventListener('clickIdUpdated', handleClickIdUpdate);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('clickIdUpdated', handleClickIdUpdate);
        };
    }, []);

    return (
        <>
            <div className={`d-inline-flex ${isColumn} align-items-center`}>
                <Link to={`/${lang}/iOSInvitation`}>
                    <img className='app-button-app-store' src={appStoreLogo} style={{ height: '40px' }} alt="App Store" />
                </Link>
                <a target="_blank" rel="noopener noreferrer" href={playStoreUrl}>
                    <img className='app-button-google-play' src={googlePlayLogo} style={{ height: '57px', width: '143px' }} alt="Google Play" />
                </a>
            </div>

            {/* Bootstrap Modal for "App Coming Soon" */}
            <Modal show={show} onHide={handleClose} className='mt-5'>
                <Modal.Header closeButton>
                    <Modal.Title>App Coming Soon</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Our app is not available yet. Stay tuned, it's coming soon!
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
